import { useCallback } from "react";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import {
  hasPlatformPermission,
  hasKnownPlatformPermissions,
  type PlatformPermissionKey,
} from "@/utils/accessControl";

export interface PlatformPermissions {
  canRead: (resource: string) => boolean;
  canAdminister: (resource: string) => boolean;
  hasPlatformPermissions: boolean;
}

export const usePlatformPermissions = (): PlatformPermissions => {
  const { userProfile } = useAuthenticatedUser();

  const canRead = useCallback(
    (resource: string): boolean =>
      hasPlatformPermission(
        userProfile,
        `platform:${resource}:read` as PlatformPermissionKey,
      ),
    [userProfile],
  );

  const canAdminister = useCallback(
    (resource: string): boolean =>
      hasPlatformPermission(
        userProfile,
        `platform:${resource}:administrate` as PlatformPermissionKey,
      ),
    [userProfile],
  );

  return {
    canRead,
    canAdminister,
    hasPlatformPermissions: hasKnownPlatformPermissions(userProfile),
  };
};
